export const VEHICLE_VALIDATION_MESSAGES = {
  vehiclePlate: "Placa do veículo é obrigatória.",
  renavam: "Renavam é obrigatório.",
  ufVeiculo: "UF Veículo é obrigatória.",
  vehicleType: "Tipo de Veículo é obrigatório.",
  rntrc: "RNTRC é obrigatório.",
  tipoRNTRC: "Tipo RNTRC é obrigatório.",
  bodyworkType: "Tipo Carroceria é obrigatório.",
  documentCRLV: "CRLV é obrigatório.",
  documentAnttFrontImg: "Doc ANTT é obrigatório.",
  reboqueRequired:
    "É necessário cadastrar pelo menos 1 reboque completo para o tipo de veículo selecionado.",
};

export const REBOQUE_REQUIRED_FIELD_LABELS = {
  placaReboque: "Placa Reboque",
  renavamReboque: "Renavam Reboque",
  ufReboque: "UF Reboque",
  rntrcReboque: "RNTRC Reboque",
  tipoRNTRCReboque: "Tipo RNTRC Reboque",
  TipoCarroceriaReboque: "Tipo Carroceria Reboque",
  anttReboque: "ANTT Reboque",
};

export const getReboqueFieldRequiredMessage = (index, fieldKey) => {
  const label = REBOQUE_REQUIRED_FIELD_LABELS[fieldKey] || fieldKey;
  return `Reboque #${index + 1}: ${label} é obrigatório.`;
};
